import {Suspense} from 'react';

import useCurrentUserQuery from '@/shared/queries/useCurrentUserQuery';
import {ApiErrorBoundary} from '@/shared/ui/api-error-boundary';
import {ErrorMessage} from '@/shared/ui/error-message';
import {Loading} from '@/shared/ui/loading';
import {useQueryClient} from '@tanstack/react-query';

import PassnoteApplyList from '../components/PassnoteApplyList';
import usePassnoteApplyHireListQuery, {
  getPassnoteApplyHireListQueryKeys,
} from '../queries/usePassnoteApplyPassHireQuery';

import PassnoteApplyHireList from './PassnoteApplyHireList';

const PassnoteApplyHireListSuspense = () => {
  const {user} = useCurrentUserQuery();
  const queryClient = useQueryClient();

  const onReset = () => {
    queryClient.resetQueries({queryKey: getPassnoteApplyHireListQueryKeys()});
  };

  const {data} = usePassnoteApplyHireListQuery(user?.institutionId, {
    enabled: false,
  });

  return (
    <PassnoteApplyList title="최종 취업자 리스트" listCount={data?.length}>
      <ApiErrorBoundary fallback={ErrorMessage} onReset={onReset}>
        <Suspense fallback={<Loading />}>
          <PassnoteApplyHireList key={user.institutionId} />
        </Suspense>
      </ApiErrorBoundary>
    </PassnoteApplyList>
  );
};

export default PassnoteApplyHireListSuspense;
